<template>
  <div>
    <v-card flat>
      <v-container fluid>
        <v-layout row wrap class="justify-space-between">
          <v-flex xs12 lg6>
            <HostDetails
              v-if="host != null"
              :edit-mode="editMode"
              :id="host._id"
              @reload="updateHost"
            />
          </v-flex>
          <v-flex xs12 lg5>
            <FormLine
              :edit-mode="editMode"
              :item="{
                value: () => item.status || 'en_cours',
                as: 'select',
                items: projectStatusItems,
                label: 'Status',
                update: value => updateProposalStatus(value)
              }"
            />

            <v-alert
              :value="host != null && host.addressObject == null"
              type="warning"
              class="ml-3 mr-1 mt-2"
              >L'adresse exacte du bien n'a pas été saisie</v-alert
            >

            <v-alert
              :value="item.disabled"
              type="warning"
              class="ml-3 mr-1 mt-2"
              >Cette proposition est désactivée</v-alert
            >

            <h3>Visite</h3>

            <v-list>
              <template>
                <v-list-tile>
                  <v-list-tile-content class="left"
                    >Visite planifiée</v-list-tile-content
                  >
                  <v-list-tile-action class="right" v-if="editMode">
                    <v-switch
                      :input-value="false"
                      v-if="item.visited == null"
                      @change="updateDateVisite()"
                    />
                    <v-menu offset-y v-else z-index="99999">
                      <template v-slot:activator="{ on }">
                        <v-btn flat color="secondary" v-on="on">Annuler</v-btn>
                      </template>
                      <v-list>
                        <v-list-tile>
                          <v-list-tile-title @click="cancelVisit('hil')"
                            >Annulation HiL</v-list-tile-title
                          >
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-title @click="cancelVisit('agency')"
                            >Annulation Agence</v-list-tile-title
                          >
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-title @click="cancelVisit('client')"
                            >Annulation Client</v-list-tile-title
                          >
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-title @click="cancelVisit('error')"
                            >Erreur</v-list-tile-title
                          >
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-list-tile-action>
                </v-list-tile>
                <v-list-tile v-if="item.visited != null">
                  <v-list-tile-content class="left">Date</v-list-tile-content>
                  <v-list-tile-action class="right">
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-left="210"
                      lazy
                      transition="scale-transition"
                      left
                      v-model="showDatePicker"
                      v-if="editMode"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="readableDate"
                          append-icon="event"
                          @click:append="showDatePicker = true"
                          :read-only="showDatePicker"
                          @input="updateDateVisite($event, 'date')"
                        />
                      </template>
                      <v-date-picker
                        v-model="dateVisite"
                        no-title
                        scrollable
                        @input="updateDateVisite()"
                      />
                    </v-menu>
                    <div v-else>{{ readableDate }}</div>
                  </v-list-tile-action>
                </v-list-tile>
                <v-list-tile v-if="item.visited != null">
                  <v-list-tile-content class="left">Heure</v-list-tile-content>
                  <v-list-tile-action class="right">
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      :nudge-left="210"
                      lazy
                      left
                      transition="scale-transition"
                      v-model="showTimePicker"
                      v-if="editMode"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="timeVisite"
                          append-icon="access_time"
                          @click:append="showTimePicker = true"
                          :read-only="showTimePicker"
                          @input="updateDateVisite($event, 'time')"
                        />
                      </template>
                      <v-time-picker
                        v-model="timeVisite"
                        :allowed-minutes="
                          m =>
                            [
                              0,
                              5,
                              10,
                              15,
                              20,
                              25,
                              30,
                              35,
                              40,
                              45,
                              50,
                              55
                            ].indexOf(m) !== -1
                        "
                        format="24hr"
                        @input="updateDateVisite()"
                      >
                        <v-spacer></v-spacer>
                      </v-time-picker>
                    </v-menu>
                    <div v-else>{{ timeVisite }}</div>
                  </v-list-tile-action>
                </v-list-tile>
                <v-list-tile v-if="editMode && item.visited != null">
                  <v-btn
                    block
                    :loading="isSendingNotification"
                    :disabled="
                      !host ||
                        !host.addressObject ||
                        isSendingNotification ||
                        isNotificationSent
                    "
                    :class="{ success: isNotificationSent, error: showError }"
                    @click="notifyClientForVisitation"
                  >
                    <template v-if="!isNotificationSent">
                      <v-icon>send</v-icon>
                      <span class="ml-2">
                        Informer le client d'une mise à jour
                      </span>
                    </template>
                    <template v-else> Une notification a été envoyée </template>
                  </v-btn>
                </v-list-tile>
                <FormLine
                  v-if="item.visited != null"
                  :edit-mode="editMode"
                  :item="{
                    value: () => item.visited.author,
                    as: 'select',
                    items: visitAuthors,
                    label: 'Qui était là ?',
                    update: value => setAuthor(value)
                  }"
                ></FormLine>
                <FormLine
                  v-if="item.visited != null && item.visited.author == 'other'"
                  :edit-mode="editMode"
                  :item="{
                    value: () => authorOther,
                    label: 'C\'est qui l\'autre ?',
                    update: value => setAuthor('other', value)
                  }"
                ></FormLine>
                <FormLine
                  v-if="item.visited != null"
                  :edit-mode="editMode"
                  :item="{
                    value: () => item.folderStatus,
                    as: 'select',
                    items: folderStatusItems,
                    label: 'Dossier',
                    update: value => updateFolderStatus(value)
                  }"
                ></FormLine>
                <div v-if="item.visited && item.visited.report">
                  <h3>Compte rendu de visite</h3>
                  <p class="ml-3 mt-2">
                    {{ item.visited.report }}
                  </p>
                </div>
              </template>
            </v-list>
            <h3>Distances</h3>
            <div class="mx-2">
              <v-container fluid>
                <v-layout row justify-center wrap>
                  <v-flex xs6 lg3 v-if="item.distanceCar != null">
                    <v-icon>directions_car</v-icon>
                    {{ item.distanceCar | time }}
                  </v-flex>
                  <v-flex xs6 lg3 v-if="item.distanceCar != null">
                    <v-icon>directions_subway</v-icon>
                    {{ item.distanceTransport | time }}
                  </v-flex>
                  <v-flex xs6 lg3 v-if="item.distanceCar != null">
                    <v-icon>directions_run</v-icon>
                    {{ item.distanceWalk | time }}
                  </v-flex>
                  <v-flex
                    xs6
                    lg3
                    class="justify-end d-flex"
                    v-if="
                      project.addressWork != null && project.addressWork !== ''
                    "
                  >
                  </v-flex>
                  <v-flex xs12 lg3 class="justify-end d-flex red--text" v-else>
                    Pas d'adresse
                  </v-flex>
                </v-layout>
              </v-container>
              <template v-if="editMode">
                <h3>Actions</h3>
                <v-container fluid>
                  <v-layout row justify-space-between wrap>
                    <v-flex>
                      <v-btn
                        flat
                        color="primary"
                        v-if="!isFinal"
                        @click="toggleFinal()"
                        >C'est le bien final</v-btn
                      >
                      <v-btn flat color="red" v-else @click="toggleFinal()"
                        >Ce n'est pas le bien final</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </template>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-snackbar v-model="showError" :timeout="7000"
        >Une erreur a eu lieu</v-snackbar
      >
    </v-card>
    <v-card class="floating-window-2">
      <ProposalComments
        :proposal="item"
        @pushComment="addComment($event)"
        @removeComment="removeComment($event)"
      />
    </v-card>
  </div>
</template>
<script>
import { fetchHil } from "@/utils";
import HostDetails from "../hosts/HostDetails";
import ProposalComments from "../project/ProposalComments";
import moment from "moment";
import {
  FOLDER_STATUS,
  PROJECT_STATUS,
  VISIT_AUTHORS
} from "@/data/DefaultSettings";
import FormLine from "../commons/FormLine";
import { mapActions, mapState } from "vuex";

export default {
  name: "ProjectProposition",
  props: ["item", "editMode"],
  components: {
    HostDetails,
    ProposalComments,
    FormLine
  },
  data() {
    return {
      host: null,
      showError: false,
      dateVisite: null,
      timeVisite: null,
      showDatePicker: false,
      showTimePicker: false,
      authorOther: null,
      isSendingNotification: false,
      isNotificationSent: null
    };
  },

  async mounted() {
    this.host = this.item._host;
    this.authorOther = this.item.visited?.authorOther;
    this.dateVisite =
      this.item.visited != null
        ? moment(this.item.visited.dateVisite).format("YYYY-MM-DD")
        : null;
    this.timeVisite =
      this.item.visited != null
        ? moment(this.item.visited.dateVisite).format("HH:mm")
        : null;
  },
  computed: {
    ...mapState("projects", {
      project: state => state.current
    }),

    readableDate() {
      return moment(this.dateVisite).format("DD/MM/YYYY");
    },
    isFinal() {
      return this.project.chosenEstate === this.item.idSell;
    },
    folderStatusItems() {
      if (this.item.folderStatus === "rejected") {
        return FOLDER_STATUS.filter(
          ({ value }) => !value.startsWith("rejected_")
        );
      } else {
        return FOLDER_STATUS;
      }
    },
    projectStatusItems() {
      return PROJECT_STATUS;
    },
    disableJustifications() {
      return PROJECT_STATUS.filter(({ value }) => value.startsWith("denied_"));
    },
    visitAuthors() {
      return VISIT_AUTHORS;
    }
  },
  methods: {
    ...mapActions("projects", ["fetchProposals", "fetchProject"]),

    async cancelVisit(reason) {
      try {
        await this.updateProposal({
          visited: null,
          visitCancelReason: reason,
          visitCancelled: true
        });
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
      this.$forceUpdate();
    },

    async updateDateVisite(input = null, validation = null) {
      if (validation === "date") {
        if (!/^[0123]\d\/[01]\d\/20\d\d$/.test(input)) {
          return;
        } else {
          this.dateVisite = moment(input, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
      if (validation === "time") {
        if (!/^[012]\d:\d\d$/.test(input)) {
          return;
        } else {
          this.timeVisite = input;
        }
      }
      const visited = { ...this.item.visited, dateVisite: moment().format() };
      if (this.dateVisite != null) {
        visited.dateVisite = moment(
          `${this.dateVisite}T${this.timeVisite}`
        ).format();
      }
      try {
        await this.updateProposal({
          visited,
          folderStatus: this.item.folderStatus || "unknown"
        });
        this.dateVisite = moment(this.item.visited.dateVisite).format(
          "YYYY-MM-DD"
        );
        this.timeVisite = moment(this.item.visited.dateVisite).format("HH:mm");
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
      this.$forceUpdate();
    },

    async notifyClientForVisitation() {
      this.isSendingNotification = true;

      const resp = await fetchHil(
        `/proposals/lease/${this.item.idBuy}/host/${this.item.idSell}/notify`,
        {
          method: "POST",
          body: {
            date: this.dateVisite,
            time: this.timeVisite,
            address: this.host.address
          }
        }
      );

      this.isSendingNotification = false;

      if (resp.ok) {
        this.isNotificationSent = true;
      } else {
        this.showError = true;
      }
    },

    async updateHost(host) {
      this.host = host;
    },

    async updateProposal(data) {
      const resp = await fetchHil(
        `/proposals/lease/${this.item.idBuy}/host/${this.item.idSell}`,
        {
          method: "PUT",
          body: data
        }
      );
      if (!resp.ok) {
        console.error(await resp.text());
        this.showError = true;
        throw new Error("http error");
      }
      await this.fetchProposals({
        id: this.project._id
      });
    },

    async addComment(message) {
      try {
        await this.updateProposal({
          comments: [...(this.item.comments || []), message]
        });
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
    },

    async removeComment(id) {
      if (confirm("Etes vous sûr ?")) {
        try {
          await this.updateProposal({
            comments: this.item.comments.filter((x, i) => i !== id)
          });
        } catch (err) {
          console.error(err);
          this.showError = true;
        }
      }
    },

    async toggleFinal() {
      try {
        const proj = this.project;

        const resp = await fetchHil(`/lease/${proj._id}`, {
          method: "PUT",
          body: {
            chosenEstate:
              proj.chosenEstate != null && proj.chosenEstate !== ""
                ? ""
                : this.item.idSell
          }
        });
        if (!resp.ok) {
          console.error(await resp.text());
          this.showError = true;
        }
        await this.fetchProject({
          id: proj._id
        });
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
      this.$forceUpdate();
    },

    async setAuthor(std, other = undefined) {
      try {
        this.authorOther = other;
        await this.updateProposal({
          visited: {
            ...this.item.visited,
            author: std,
            authorOther: other
          }
        });
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
      this.$forceUpdate();
    },

    async setAvailability(av, status = "en_cours") {
      try {
        await this.updateProposal({
          disabled: !av,
          status
        });
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
      this.$forceUpdate();
    },

    async updateFolderStatus(value) {
      try {
        if (value === "rejected_agency") {
          await this.updateProposal({
            folderStatus: "rejected",
            status: "denied_agency"
          });
        } else if (value === "rejected_customer") {
          await this.updateProposal({
            folderStatus: "rejected",
            status: "denied_customer"
          });
        } else {
          await this.updateProposal({ folderStatus: value });
        }
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
      this.$forceUpdate();
    },

    async updateProposalStatus(value) {
      try {
        if (value.startsWith("denied_")) {
          this.setAvailability(false, value);
        } else {
          this.setAvailability(true, value);
        }
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
      this.$forceUpdate();
    }
  }
};
</script>
<style>
.floating-window-2 {
  position: fixed;
  width: 400px;
  right: 20px;
  z-index: 10000;
  top: 69px;
}

@media screen and (max-width: 939px) {
  .floating-window-2 {
    width: calc(100vw - 20px);
    right: 10px;
    left: 10px;
  }
}
</style>
